module.exports = __webpack_public_path__ + "img/frame (278).04423df5.jpg";